export default __webpack_public_path__ + "static/1306-17665b0b1803ad8e7d1f9566cef05a29.gif";